import styled from 'styled-components'

import { color, font } from '~/styles/utils'

export const Wrapper = styled.div`
  margin: 0;
`

export const PaymentSubtitle = styled.h3`
  margin: 16px 7px 10px 0;
  font-size: 16px;
  line-height: 20px;
  ${font('bold')};

  color: ${({ theme }) => theme.color.text.headline};
  text-transform: uppercase;
`

export const PaymentText = styled.div`
  margin: 0;
  width: 100%;
  height: auto;
  ${font('base')};
  font-size: 14px;
  line-height: 1.21;
  letter-spacing: normal;
  color: ${color('darkGrey')};
  overflow: visible;
  white-space: normal;
`
